module.exports = __webpack_public_path__ + "static/aura-a52facaaca0d609d2268d521ecd1a465.jpg";